/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The TenantSettingskeyTenantSetting model module.
 * @module model/TenantSettingskeyTenantSetting
 * @version v0.3
 */
export default class TenantSettingskeyTenantSetting {
  /**
   * Constructs a new <code>TenantSettingskeyTenantSetting</code>.
   * @alias module:model/TenantSettingskeyTenantSetting
   * @class
   * @param value {String} 
   */
  constructor(value) {
    this.value = value;
  }

  /**
   * Constructs a <code>TenantSettingskeyTenantSetting</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TenantSettingskeyTenantSetting} obj Optional instance to populate.
   * @return {module:model/TenantSettingskeyTenantSetting} The populated <code>TenantSettingskeyTenantSetting</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TenantSettingskeyTenantSetting();
      if (data.hasOwnProperty('value'))
        obj.value = ApiClient.convertToType(data['value'], 'String');
      if (data.hasOwnProperty('tenant_id'))
        obj.tenantId = ApiClient.convertToType(data['tenant_id'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} value
 */
TenantSettingskeyTenantSetting.prototype.value = undefined;

/**
 * @member {String} tenantId
 */
TenantSettingskeyTenantSetting.prototype.tenantId = undefined;

